'use client'

import type { AitypesInsight } from '@polaris/api-client'
import { cn } from '@/src/utils/styles'
import { InsightCardLink } from '../ui/insights/insight-card-link'
import { InsightCardSubject } from '../ui/insights/insight-card-subject'
import { InsightImage } from '../ui/insights/insight-image'
import { TokenPriceIndicator } from './token-price-indicator'

interface InsightCardProps {
  insight: AitypesInsight
  className?: string
  index?: number
}
export function InsightCardSkeleton() {
  return (
    <div className='block transition-transform duration-300 ease-out my-3'>
      <div className='flex gap-3'>
        <div className='w-[104px] h-[104px] bg-surface1-100 rounded-xl animate-pulse shrink-0' />
        <div className='flex-1 min-w-0 flex flex-col gap-1.5 justify-between overflow-hidden'>
          <div className='space-y-1'>
            <div className='h-[24px] w-full bg-surface1-100 rounded animate-pulse' />
            <div className='h-[24px] w-3/4 bg-surface1-100 rounded animate-pulse' />
          </div>
          <div className='h-[20px] w-[120px] bg-surface1-100 rounded animate-pulse' />
        </div>
      </div>
    </div>
  )
}
export function InsightCard({ insight, className }: InsightCardProps) {
  return (
    <InsightCardLink insight={{ ...insight, highlight: false }}>
      <div className={cn('flex gap-3 p-2 rounded-2xl', className)}>
        <div className='shrink-0'>
          <InsightImage insight={insight} variant='card' />
        </div>

        {/* Content */}
        <div className='flex-1 min-w-0 flex flex-col gap-1.5 justify-between overflow-hidden'>
          <h3 className='text-primary font-semibold text-base leading-6 line-clamp-3'>
            {insight.headline}
          </h3>

          <div className='flex gap-1 items-center'>
            <InsightCardSubject insight={insight} variant='v2' />
            {insight.subjectSelector && (
              <TokenPriceIndicator
                chainId={insight.subjectValue?.chainId}
                denom={insight.subjectValue?.denom}
              />
            )}
          </div>
        </div>
      </div>
    </InsightCardLink>
  )
}
